module.exports = __webpack_public_path__ + "static/media/wcgLogo.a1ca7a44.png";